<template>
    <div class="login-panel">
        <div class="title_img">

        </div>
        <div class="login">
            <div class="login_title">
                <span>用户登录</span>
            </div>
            <el-form :model="loginForm" :rules="rules" ref="loginForm" class="loginForm" @keyup.enter="login">
                <el-form-item prop="uid">
                    <el-input v-model="loginForm.uid" placeholder="输入登录账号" class="nobr" autocomplete="off">
                        <i slot="prefix" class="el-icon-user"></i>
                    </el-input>
                </el-form-item>

                <el-form-item prop="pwd">
                    <el-input show-password v-model="loginForm.pwd" placeholder="请输入登录密码" class="nobr"
                        autocomplete="off">
                        <i slot="prefix" class="el-icon-lock"></i>
                    </el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" class="nobr loginbtn" style="" :loading="loading"
                        @click="login()">登录</el-button>
                    <el-button type="primary" class="nobr registerbtn" style="" :loading="loading"
                        @click="goRegister()">注册</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>

import router from '@/router';
import { useRouter, useRoute } from 'vue-router';

import { userLogin } from '@/api/Common.js';
import { useMapStore } from '@/stores/mapStore';

export default {
    name: 'Login',
    components: {

    },
    data() {
        let validUserName = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("用户名不能为空"));
            } else {
                callback();
            }
        };

        let validPassword = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("密码不能为空"));
            } else {
                callback();
            }
        };
        return {
            loginForm: {
                uid: "",
                pwd: "",
                type: "1"
            },
            rules: {
                uid: [{ validator: validUserName, trigger: "blur" }],
                pwd: [{ validator: validPassword, trigger: "blur" }],
            },
            router: null,
            loading: false,
            mapStore: null,

        }
    },
    mounted() {

        this.router = useRouter();
        this.mapStore = useMapStore();
    },
    methods: {
        async login() {
            this.loading = true; // 开始加载
            try {
                let that = this;
                const res = await userLogin({
                    "userName": this.loginForm.uid,
                    "passWord": this.loginForm.pwd,
                    "type": this.loginForm.type,
                });
                if (res.code == 200) {
                    localStorage.setItem("token", res.token);
                    localStorage.setItem("userInfo", JSON.stringify(res.sysUser));
                    localStorage.removeItem("userJurisdiction");
                    that.mapStore.loadCodeList();
                    that.mapStore.loadUserJurisdiction(
                        () => {
                            that.router.push({ path: "/map/home" });
                        }
                    );
                    // that.router.push({ path: "/map/home" });
                }
            } catch (error) {
                console.error('登录失败:', error);
            } finally {
                this.loading = false; // 结束加载
            }
        },
        goRegister() {
            this.router.push({ path: "/register" });
        }
    }
}
</script>

<style scoped>
.login-panel {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;

    background: url("../assets/images/login.jpg") no-repeat center;
    background-size: 100% 100%;
}

.login {
    width: 472px;
    height: 421px;
    position: absolute;
    left: 75%;
    top: 45%;
    transform: translate(-50%, -40%);
    background: rgba(255, 255, 255, 0.9);
    border-radius: 8px;
}

.login_title {
    margin-top: 47px;
    margin-left: 48px;
    font-size: 25px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #3b4d6e;
    /* background-color: #bfa; */
}

.loginForm {
    margin-top: 61px;
    margin-left: 48px;
    /* background-color: #bfa; */
    width: 385px;
}

.el-form-item {
    /* margin-bottom: 12px; */
    height: 41px;
}

.el-input /deep/ .el-input__inner {
    /* background: rgba(80, 152, 255, 0.24); */
    border-color: rgba(0, 0, 0, 0.1);
    color: #000;
}

.el-input /deep/ .el-input-group__prepend {
    border: 0;
    padding: 0 !important;
}

.loginbtn {
    width: 180px;
    height: 50px;
    background: #3b4d6e;
    border-radius: 5px;
}

.registerbtn {
    width: 180px;
    height: 50px;
    background: #3b4d6e;
    border-radius: 5px;
}
</style>